import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

export default function ShareLot({ lot }) {
  const [t] = useTranslation();
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);

  // Composant icône X personnalisé
  const XIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );

  // Construire l'URL actuelle du lot
  const lotUrl = `${window.location.origin}/lot/${lot._id}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(lotUrl);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error("Erreur lors de la copie:", err);
      // Fallback pour les navigateurs plus anciens
      const textArea = document.createElement("textarea");
      textArea.value = lotUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };

  const shareOnFacebook = () => {
    const shareUrl = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
      lotUrl
    )}`;
    window.open(shareUrl, "_blank", "noopener,noreferrer");
  };

  const shareOnX = () => {
    const text = `${t("Share.Check-Out-Lot")}: Lot ${lot.number} - ${
      lot.title
    }`;
    const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      text
    )}&url=${encodeURIComponent(lotUrl)}`;
    window.open(shareUrl, "_blank", "noopener,noreferrer");
  };

  const shareByEmail = () => {
    const subject = `${t("Share.Check-Out-Lot")}: Lot ${lot.number} - ${
      lot.title
    }`;
    const body = `${t("Share.I-Found-This-Lot")}: ${lot.title}\n\n${lotUrl}`;
    const mailtoUrl = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoUrl;
  };

  return (
    <>
      <button
        className="btn share-btn"
        onClick={() => setShareDialogOpen(true)}
        title={t("Share.Share-Lot")}
      >
        <ShareIcon /> {t("Share.Share")}
      </button>

      <Dialog
        open={shareDialogOpen}
        onClose={() => setShareDialogOpen(false)}
        className="share-dialog"
        maxWidth="sm"
      >
        <DialogTitle className="share-dialog-title">
          {t("Share.Share-This-Lot")}
          <button
            className="close-btn"
            onClick={() => setShareDialogOpen(false)}
            title="Fermer"
          >
            <CloseIcon />
          </button>
        </DialogTitle>
        <DialogContent className="share-dialog-content">
          <div className="lot-preview">
            <h4>
              Lot {lot.number} - {lot.title}
            </h4>
            <p className="lot-url">{lotUrl}</p>
          </div>

          <div className="share-options">
            <button
              className="share-option-btn facebook-btn"
              onClick={shareOnFacebook}
            >
              <FacebookIcon />
              <span>Facebook</span>
            </button>

            <button className="share-option-btn x-btn" onClick={shareOnX}>
              <XIcon />
              <span>X</span>
            </button>

            <button
              className="share-option-btn email-btn"
              onClick={shareByEmail}
            >
              <EmailIcon />
              <span>Email</span>
            </button>

            <button
              className="share-option-btn copy-btn"
              onClick={copyToClipboard}
            >
              <ContentCopyIcon />
              <span>
                {copySuccess ? t("Share.Copied") : t("Share.Copy-Link")}
              </span>
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
